import React, { useState } from 'react'
import { UserAndRollColumns, UserAndRollTableData } from './UserandRollData';

import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';

const UserAndRollTable = ({ editModal }) => {
    const [data, setData] = useState(UserAndRollTableData)
    const handleDelete = (id) => {
        setData(prevData => prevData.filter(item => item.Id !== id));
    }
    const dataT = data.map((data) => {
        return {
            id: data.Id,
            name: data.name,
            action: (
                <div className='text-center'>
                    <button
                        type="button"
                        className="text-dark hover:opacity-50 focus:outline-none rounded-md p-2"
                        onClick={() => editModal(true)}
                    >
                        <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                        type="button"
                        className="= text-red-700 hover:text-red-800 focus:outline-none rounded-md p-2"
                        onClick={() => handleDelete(data.Id)}
                    >
                        <i className="bi bi-trash"></i>
                    </button>

                </div>
            ),
        };
    });
    return (
        <div className='h-full px-4'>
            <DataTableHeader />
            <DataTable columns={UserAndRollColumns} data={dataT} />
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default UserAndRollTable;